import React, { ReactNode, useCallback, useMemo, useState } from 'react';

import ElectricBorder from '@/features/Dashboard/components/ElectricBorder/ElectricBorder';

import { WidgetAnimationContext } from './context';

export const WidgetAnimationProvider = ({
  children,
  animationTime = 3000
}: {
  children: ReactNode;
  animationTime?: number;
}) => {
  const [elementsToAnimateId, setElementsToAnimateId] = useState<string[] | null>(null);

  const renderWithAnimation = useCallback((element: ReactNode) => {
    return <ElectricBorder color='#E84E0F'>{element}</ElectricBorder>;
  }, []);

  const value = useMemo(
    () => ({
      elementsToAnimateId,
      setElementsToAnimateId,
      renderWithAnimation,
      animationTime
    }),
    [elementsToAnimateId, renderWithAnimation, animationTime]
  );
  return (
    <WidgetAnimationContext.Provider value={value}>{children}</WidgetAnimationContext.Provider>
  );
};
